import React from "react";
import { useNavigate } from "react-router-dom";
import { AppBar, Box, Toolbar } from "@mui/material";
import farmAppLogo from "../assets/logo/FarmAppLogo.png";

const SimpleHeader = () => {

  const navigate = useNavigate();
  return (
    <AppBar
      position="sticky"
      color="default"
      elevation={1}
      sx={{ padding: "10px 0" }}
    >
      <Toolbar>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }} onClick={() => navigate("/")}>
          <img
            src={farmAppLogo}
            alt="FarmApp Logo"
            style={{ height: "60px", width: "auto" }}
          />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default SimpleHeader;
